<template>
  <div>
    <v-dialog
      v-model="showDialog"
      max-width="400px"
    >
      <v-card>
        <v-card-text>
          <div class="mb-3 title">
            {{ name }}
          </div>
          <slot />
          <v-layout class="mt-4">
            <v-btn
              flat
              class="mx-4"
              @click="close"
            >
              {{ disagreeText }}
            </v-btn>
            <v-flex class="pl-4">
              <v-btn
                color="info"
                block
                @click="agree"
              >
                {{ agreeText }}
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: 'AgreeServiceConfirm',
  props: {
    name: {
      type: String,
      default: '服務協議'
    },
    agreeText: {
      type: String,
      default: '同意'
    },
    disagreeText: {
      type: String,
      default: '不同意'
    },
  },
  data () {
    return {
      cb: null,
      showDialog: false
    }
  },
  watch: {
    showDialog (val) {
      if (!val) {
        this.cb(false)
      }
    }
  },
  mounted () {
    // this.open()
  },
  methods: {
    open () {
      return new Promise((resolve, reject) => {
        this.cb = resolve
        this.showDialog = true
      })
    },
    close () {
      this.showDialog = false
    },
    agree () {
      this.cb(true)
      this.showDialog = false
    }
  }
}
</script>
<style lang="postcss" scoped>
.sheet {
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}
</style>
